import { useTranslation } from 'react-i18next';
import useFileStore from '../../stores/fileStore';
import { getFileName, isCanvasFile } from '../../utils/fileSystem';
import './EditorTabs.css';

function EditorTabs({ projectId }) {
    const { t } = useTranslation();
    const { openTabs, activeTabPath, setActiveTab, closeTab, isUnsaved } = useFileStore();

    if (openTabs.length === 0) {
        return null;
    }

    const handleClose = (e, path) => {
        e.stopPropagation();
        closeTab(path);
    };

    const getTabIcon = (path) => {
        if (isCanvasFile(path)) return '🎨';
        return '📄';
    };

    return (
        <div className="editor-tabs">
            <div className="tabs-scroll">
                {openTabs.map(path => (
                    <div
                        key={path}
                        className={`tab ${activeTabPath === path ? 'active' : ''}`}
                        onClick={() => setActiveTab(path)}
                    >
                        <span className="tab-icon">{getTabIcon(path)}</span>
                        <span className="tab-name">{getFileName(path)}</span>
                        {isUnsaved(path) && <span className="tab-unsaved">•</span>}
                        <button
                            className="tab-close"
                            onClick={(e) => handleClose(e, path)}
                            title={t('editor.closeTab')}
                        >
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default EditorTabs;
